// Archivo autogenerado con las Notas Legales Oficiales de Sección y Capítulo de la LIGIE (DOF)
// Contiene la totalidad de los 98 Capítulos y 22 Secciones con sus notas de exclusión, inclusión y subpartida.

export interface NotaLegalCapitulo {
  capitulo: string;
  titulo: string;
  seccion: string;
  seccionTitulo: string;
  notasSeccion: string;
  notasCapitulo: string;
  notasSubpartida?: string;
  exclusionesClave: string[];
  inclusionesClave: string[];
  criterioClave: string;
}

import dataJson from './notasCapitulosLigie.json';

export const NOTAS_CAPITULOS_LIGIE: Record<string, NotaLegalCapitulo> = dataJson as Record<string, NotaLegalCapitulo>;

export const obtenerNotasCapitulo = (codigoOCapitulo: string): NotaLegalCapitulo | undefined => {
  if (!codigoOCapitulo) return undefined;
  // Extraer los primeros 2 dígitos
  const limpio = codigoOCapitulo.replace(/\D/g, '');
  const cap = limpio.slice(0, 2).padStart(2, '0');
  return NOTAS_CAPITULOS_LIGIE[cap];
};

export const buscarNotasPorTexto = (termino: string): NotaLegalCapitulo[] => {
  if (!termino || !termino.trim()) return [];
  const q = termino.toLowerCase().trim();
  return Object.values(NOTAS_CAPITULOS_LIGIE).filter(nota => 
    nota.capitulo.includes(q) ||
    nota.titulo.toLowerCase().includes(q) ||
    nota.notasCapitulo.toLowerCase().includes(q) ||
    (nota.notasSubpartida && nota.notasSubpartida.toLowerCase().includes(q)) ||
    nota.notasSeccion.toLowerCase().includes(q)
  );
};
